/* KTS hide-soldout v1 — oculta del picker los valores de opción sin NINGUNA variante disponible.
   (Valores con alguna variante disponible —p.ej. una tapa acrílica agotada solo en Walnut— siguen visibles.)
   Si el valor seleccionado queda oculto, selecciona el primero visible. */
(function () {
  function run() {
    var vs = document.querySelector('variant-selects, variant-radios');
    if (!vs) return;
    var path = window.location.pathname.split('?')[0];
    fetch(path + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return;
        var fieldsets = vs.querySelectorAll('fieldset');
        fieldsets.forEach(function (fs, idx) {
          var inputs = fs.querySelectorAll('input[type="radio"]');
          if (inputs.length < 2) return; /* nunca vaciar un picker de un solo valor */
          var hidden = 0;
          inputs.forEach(function (inp) {
            var any = p.variants.some(function (v) {
              return v['option' + (idx + 1)] === inp.value && v.available;
            });
            if (!any && hidden < inputs.length - 1) {
              inp.style.display = 'none';
              var lab = fs.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(inp.id) : inp.id) + '"]');
              if (lab) lab.style.display = 'none';
              hidden++;
            }
          });
          var checked = fs.querySelector('input:checked');
          if (checked && checked.style.display === 'none') {
            var first = Array.prototype.find.call(inputs, function (i) { return i.style.display !== 'none'; });
            if (first) first.click();
          }
        });
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
